;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["default-type", "default-id", "type-field", "id-field", "search-url"],
  data: function data() {
    return {
      currentType: "merchant",
      currentId: this.defaultId,
      currentOwner: {},
      typeFieldName: this.typeField || "owner_type",
      idFieldName: this.idField || "owner_id",
      types: {
        merchant: "Merchant"
      },
      ownersList: []
    };
  },

  watch: {
    currentType: function currentType(t) {
      if (t) {
        this.ownersList = [];
        this.currentOwner = {};
      }
    },
    currentOwner: function currentOwner(o) {
      if (o) {
        this.currentId = o.id;
      } else {
        this.currentId = "";
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.doSearch(this.currentType, this.defaultId).done(function (data) {
      _this.currentOwner = data.results[0];
    });
  },

  methods: {
    loadOwners: function loadOwners(name, loading) {
      if (!(name && this.currentType)) {
        return false;
      }

      loading(true);
      this.doSearch(this.currentType, name).always(function () {
        loading(false);
      });
    },
    doSearch: function doSearch(type, term) {
      var _this2 = this;

      return $.ajax({
        url: this.searchUrl,
        method: "get",
        data: {
          type: type,
          name: term
        },
        success: function success(data) {
          _this2.ownersList = data.results;
        },
        error: function error(xhr) {},
        complete: function complete() {}
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_vm._t("type-label",[_c('label',[_vm._v("Select Owner Type")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentType),expression:"currentType"}],staticClass:"form-control",attrs:{"name":_vm.typeFieldName},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentType=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.doSearch($event.target.value, '*')}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select owner type...")]),_vm._v(" "),_vm._l((_vm.types),function(v,k){return _c('option',{domProps:{"value":k}},[_vm._v(_vm._s(v))])})],2),_vm._v(" "),_vm._t("type-error")],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._t("id-label",[_vm._v(" s\n      "),_c('label',[_vm._v("Select Owner")])]),_vm._v(" "),_c('vue-select',{attrs:{"filterable":false,"placeholder":"Type here to search","label":"name","options":_vm.ownersList,"name":_vm.idFieldName,"on-search":_vm.loadOwners},model:{value:(_vm.currentOwner),callback:function ($$v) {_vm.currentOwner=$$v},expression:"currentOwner"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.idFieldName},domProps:{"value":_vm.currentId}}),_vm._v(" "),_vm._t("id-error")],2)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b671cb32", __vue__options__)
  } else {
    hotAPI.reload("data-v-b671cb32", __vue__options__)
  }
})()}